import { UserRole } from "@employee-management/common";
import { ProtectedRoute } from "@/components/auth/protected-route";
import { PageHeading } from "@/components/ui/page-heading";
import { PendingApprovalsTable } from "./components/PendingApprovalsTable";

export function PendingApprovalsView() {
  return (
    <ProtectedRoute requiredRole={UserRole.MANAGER}>
      <div className="space-y-6">
        <PageHeading
          title="Pending Approvals"
          subtitle="Review and approve overtime entries that require your attention."
        />
        <PendingApprovalsTable />
      </div>
    </ProtectedRoute>
  );
}
